import VerifiedSenders from "../singleton/verified-senders";
import Application from "../singleton/application";

export default {

    getId: Application.getId.bind(Application),

    getName: Application.getName.bind(Application),

    rename: Application.rename.bind(Application),

    getLogo: Application.getLogo.bind(Application),

    setLogo: Application.setLogo.bind(Application),

    getBrandColor: Application.getBrandColor.bind(Application),

    setBrandColor: Application.setBrandColor.bind(Application),

    getPublicEnabled: Application.getPublicEnabled.bind(Application),

    getCallUsers: Application.getCallUsers.bind(Application),

    getUsers: Application.getUsers.bind(Application),

    setUsers: Application.setUsers.bind(Application),

    attachUser: Application.attachUser.bind(Application),

    detachUser: Application.detachUser.bind(Application),

    setOwner: Application.setOwner.bind(Application),

    Sender: {

        getAll: VerifiedSenders.getAll.bind(VerifiedSenders),

        create: VerifiedSenders.create.bind(VerifiedSenders),

        verify: VerifiedSenders.verify.bind(VerifiedSenders),

        delete: VerifiedSenders.delete.bind(VerifiedSenders),

        getTimeout: VerifiedSenders.getTimeout.bind(VerifiedSenders)

    }

}